/**
 * @generated SignedSource<<29ab61746a4358b6699b84f519666674>>
 * @relayHash 3d535bc7b749fcad5ad9725606183b60
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/513.0.0-2025-06-04T15:51:23.815Z/formatCreatorsAttributeQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type formatCreatorsAttributeQuery$variables = Record<PropertyKey, never>;
export type formatCreatorsAttributeQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"formatCreatorsAttribute_viewer">;
  };
};
export type formatCreatorsAttributeQuery = {
  response: formatCreatorsAttributeQuery$data;
  variables: formatCreatorsAttributeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "names",
    "value": [
      "creatorNationality",
      "creatorStyle"
    ]
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "formatCreatorsAttributeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "formatCreatorsAttribute_viewer",
            "selections": [
              {
                "alias": null,
                "args": (v0/*: any*/),
                "concreteType": "CreatorProp",
                "kind": "LinkedField",
                "name": "creatorProperties",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": "creatorProperties(names:[\"creatorNationality\",\"creatorStyle\"])"
              }
            ],
            "args": null,
            "argumentDefinitions": []
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "formatCreatorsAttributeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*: any*/),
            "concreteType": "CreatorProp",
            "kind": "LinkedField",
            "name": "creatorProperties",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": "creatorProperties(names:[\"creatorNationality\",\"creatorStyle\"])"
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/513.0.0-2025-06-04T15:51:23.815Z/formatCreatorsAttributeQuery",
    "metadata": {},
    "name": "formatCreatorsAttributeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3f395085181e71cbd7c858614c558e28";

export default node;
